import { WebWrapper } from '@/components/WebWrapper'
import { DS } from '@/design-system'
import { Platform, StatusBar, View, ViewStyle, Image, ImageStyle } from 'react-native'
import { useSafeAreaInsets } from 'react-native-safe-area-context'
import { scale } from '../../styles/sizes'

const CONTAINER: ViewStyle = {
  flex: 1,
  backgroundColor: '#F6F2E9',
  paddingTop: Platform.OS === 'android' ? StatusBar.currentHeight : 0
}

const SUB_CONTAINER: ViewStyle = {
  position: 'absolute',
  left: 0,
  top: 0,
  width: '100%',
  height: '100%'
}

const LOADER_STYLE: ImageStyle = { width: scale(48), height: scale(48) }

export type LoaderScreenProps = { title?: string }

export function LoaderScreen(props: LoaderScreenProps) {
  const insets = useSafeAreaInsets()

  return (
    <View style={[CONTAINER, { paddingTop: insets.top }]}>
      <WebWrapper>
        <DS.Frame flex={1} justifyContent="center" alignItems="center" gap={'12'} style={SUB_CONTAINER}>
          <Image source={require('../ANewDesign/assets/Chip-Animation-Clean.gif')} style={LOADER_STYLE} />
          {props.title ? (
            <DS.Text variant="Heading 3/Regular" textAlign="center" style={{ fontSize: 24, letterSpacing: 1 }}>
              {props.title}
            </DS.Text>
          ) : null}
        </DS.Frame>
      </WebWrapper>
    </View>
  )
}
